"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEMOIZE_CLEAR_FUNCTION = Symbol('MEMOIZE_CLEAR_FUNCTION');
/**
 * Memoizes function for passed arguments
 */
function memoize(fn) {
    var storage = {};
    var result = function () {
        var args = Array.prototype.slice.call(arguments);
        var key = serialize(args);
        if (typeof storage[key] === 'undefined') {
            storage[key] = fn.apply(this, args);
        }
        return storage[key];
    }.bind(this);
    //inject clearer
    result[exports.MEMOIZE_CLEAR_FUNCTION] = function () {
        var args = Array.prototype.slice.call(arguments);
        var key = serialize(args);
        delete storage[key];
    };
    return result;
}
exports.memoize = memoize;
exports.default = memoize;
/**
 * @param {Array.<*>} args
 * @returns {String}
 */
function serialize(args) {
    var argsAreValid = args.every(function (arg) {
        return typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'boolean';
    });
    if (!argsAreValid) {
        throw Error('Arguments to memoized function can only be strings or numbers');
    }
    return JSON.stringify(args);
}
exports.memoOnce = function (E) { return function (f) {
    var hasValue = false;
    var cachedR;
    var cachedArgs = [];
    var update = function (args) {
        cachedR = f.apply(void 0, args);
        hasValue = true;
        cachedArgs = args;
    };
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var length = args.length;
        if (hasValue && length === 0) {
            return cachedR;
        }
        if (!hasValue || cachedArgs.length !== length) {
            update(args);
            return cachedR;
        }
        for (var i = 0; i < length; i++) {
            if (!E.equals(cachedArgs[i], args[i])) {
                update(args);
                return cachedR;
            }
        }
        return cachedR;
    };
}; };
//# sourceMappingURL=memoize.js.map